import React, {useState, useEffect} from 'react';
import {useOutletContext} from "react-router";
import {FormControlLabel, Radio, RadioGroup, Typography} from "@mui/material";
import {useMediaQuery} from "@mui/material";
import Grid from "@mui/material/Grid";
import {WeekPicker} from "../components/pickers/WeekPicker";
import {RosterGrid} from '../components/grids/RosterGrid';
import {config} from '../config';
import {rosterGridTypes} from "../utils";

const managerNames = config.managerNames;

export const SpreadsheetContainer = () => {
    const {currentAuction} = useOutletContext();
    const [seasonYear, setSeasonYear] = useState(null);
    const [weekNum, setWeekNum] = useState(null);
    const [pointsMode, setPointsMode] = useState(false);
    const [scheduleMode, setScheduleMode] = useState(false);

    const isMobile = useMediaQuery('(max-width: 1450px)');

    const setYearAndWeek = (year, week) => {
        setSeasonYear(year);
        setWeekNum(week);
    };

    useEffect(() => {
        setYearAndWeek(currentAuction.season_year, currentAuction.week_num);
    }, [currentAuction]);

    const handleModeChange = (event) => {
        setPointsMode(event.target.value === 'points');
        setScheduleMode(event.target.value === 'schedules');
    };

    const tableRows = [];
    if (isMobile) {
        for (let i = 0; i < 8; i++) {
            tableRows.push(
                <tr key={`tr${i}t`}>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i]}</Typography></td>
                </tr>);
            tableRows.push(
                <tr key={`tr${i}b`}>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.STANDARD} managerName={managerNames[i]}
                                    seasonYear={seasonYear} weekNum={weekNum}
                                    showPoints={pointsMode} showSchedule={scheduleMode}/>
                    </td>
                </tr>)
        }
    } else {
        for (let i = 0; i < 8; i += 2) {
            tableRows.push(
                <tr key={`tr${i}`}>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i]}</Typography></td>
                    <td><Typography variant="h6" style={{margin: 10}}>{managerNames[i + 1]}</Typography></td>
                </tr>);
            tableRows.push(
                <tr key={`tr${i + 1}`}>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.STANDARD} managerName={managerNames[i]}
                                    seasonYear={seasonYear} weekNum={weekNum}
                                    showPoints={pointsMode} showSchedule={scheduleMode}/>
                    </td>
                    <td style={{verticalAlign: 'top'}}>
                        <RosterGrid type={rosterGridTypes.STANDARD} managerName={managerNames[i + 1]}
                                    seasonYear={seasonYear} weekNum={weekNum}
                                    showPoints={pointsMode} showSchedule={scheduleMode}/>
                    </td>
                </tr>)
        }
    }

    const justify = isMobile ? 'flex-start' : 'center';
    return (
        <div>
            <Grid container justifyContent={justify}>
                <table>
                    <tbody>
                    <tr>
                        {!isMobile && <td/>}
                        <td align="right">
                            <WeekPicker setterFunction={setYearAndWeek} includeDraft={true}/> {/*TODO: maybe true during pre/draft but false in season...???*/}
                            <RadioGroup defaultValue="salaries" row onChange={handleModeChange}
                                        style={{float: "right"}}>
                                <FormControlLabel value="salaries" control={<Radio/>} label="Salaries"/>
                                <FormControlLabel value="points" control={<Radio/>} label="Points"/>
                                <FormControlLabel value="schedules" control={<Radio/>} label="Schedules"/>
                            </RadioGroup>
                        </td>
                    </tr>
                    {tableRows}
                    <tr>
                        <td style={{height: 100}}/>
                        <td style={{height: 100}}/>
                    </tr>
                    </tbody>
                </table>
            </Grid>
        </div>
    );
}